import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { FileCog } from "lucide-react";
import DatasetsTab from "./dataset-ops/DatasetsTab";
import OperationalFilesTab from "./dataset-ops/OperationalFilesTab";

export default function DatasetOperations({ token }) {
  return (
    <div className="p-8 max-w-7xl mx-auto">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl bg-violet-100 flex items-center justify-center">
          <FileCog className="w-5 h-5 text-violet-600" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Dataset Operations</h1>
          <p className="text-sm text-slate-500">Upload, validate, diff and commit datasets · manage operational config files</p>
        </div>
      </div>

      <Tabs defaultValue="datasets" data-testid="dataset-ops-tabs">
        <TabsList className="mb-5">
          <TabsTrigger value="datasets" data-testid="tab-datasets">Datasets</TabsTrigger>
          <TabsTrigger value="operational-files" data-testid="tab-operational-files">Operational Files</TabsTrigger>
        </TabsList>
        <TabsContent value="datasets">
          <DatasetsTab token={token} />
        </TabsContent>
        <TabsContent value="operational-files">
          <OperationalFilesTab token={token} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
